import Section from "@/components/Section";
import { Zap } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";

export default function FeatureAdToggle({is_featured, pricing, update}) {

	const { t } = useTranslation();

	return (
		<Section title={t('horse.featured_ad')}>
			<div className="flex items-start gap-4 p-4 bg-gradient-to-r from-[#F9F7F2] to-[#FFF8E7] rounded-sm border border-[#E6E2D6]">
				<Zap className="w-8 h-8 text-[#8B4513] flex-shrink-0 mt-1" />
				<div className="flex-1">
					<div className="flex items-center gap-3 mb-2">
						<Switch data-testid="horse-featured" checked={is_featured}
										onCheckedChange={v => update('is_featured', v)} />
						<Label className="text-sm font-semibold text-[#1A3C34]">
							{t('horse.featured_ad')}
						</Label>
					</div>
					<p className="text-sm text-[#666055] mb-1">
						{t('horse.featured_ad_desc')}
					</p>
					<p className="text-sm font-bold text-[#8B4513]" data-testid="featured-ad-price">
						{t('horse.featured_ad_price', { price: pricing.price_featured_ad?.toFixed(2) })}
					</p>
				</div>
			</div>
		</Section>

	)
}